import { isAxiosError } from 'axios';

import type { ApiError, ApiErrorType } from '@/types/common/api.type';

import { createApiError } from './api-error.factory';

const ApiError: Record<ApiErrorType, ApiErrorType> = {
    AUTH: 'AUTH',
    BUSINESS: 'BUSINESS',
    SYSTEM: 'SYSTEM',
    TRANSPORT: 'TRANSPORT',
    UNKNOWN: 'UNKNOWN',
} as const;

export const unwrapError = (error: unknown): ApiError => {
    if (isAxiosError(error)) {
        if (!error.response) {
            return createApiError({
                code: 'NETWORK_ERROR',
                message:
                    'Không thể kết nối tới máy chủ. Vui lòng kiểm tra kết nối mạng hoặc thử lại sau.',
                type: ApiError.TRANSPORT,
                raw: {
                    message: error.message,
                    code: error.code,
                },
            });
        }

        const { status, data } = error.response;

        if (status === 401 || status === 403) {
            return createApiError({
                code: 'FORBIDDEN',
                message:
                    'Bạn không có quyền, vui lòng đăng xuất hoặc liên hệ admin để được hỗ trợ.',
                status,
                type: ApiError.AUTH,
                raw: data,
            });
        }

        if (status === 400) {
            const code = data?.error?.code ?? 'BAD_REQUEST';

            return createApiError({
                code,
                message: String(code),
                status,
                type: ApiError.BUSINESS,
                raw: {
                    message: error.message,
                    code: error.code,
                },
            });
        }

        if (status >= 500) {
            return createApiError({
                code: 'SYSTEM_ERROR',
                status,
                type: ApiError.SYSTEM,
                raw: {
                    status,
                    message: 'Server error',
                },
            });
        }
    }

    return createApiError({
        code: 'UNKNOWN_ERROR',
        type: ApiError.UNKNOWN,
        raw: error,
    });
};
